import { Text, Button, ButtonHierarchies } from '@clockout-dev/design-elements';
import styles from './styles/signInRedirect.module.scss';

export default function SigninRedirect({ loading, navigateLogin }) {
    return (
        <div className={styles.signInRedirectContainer}>
            <Text as="span" size="m">Already have an account?</Text>
            <Button
                type="button"
                hierarchy={ButtonHierarchies.GHOST}
                loading={loading}
                onClick={() => navigateLogin()}
            >
                Sign in
            </Button>
        </div>
    );
}
